var REDIRECT_PATH = "/error";

angular.module('CarsSaraBo').config(['$routeProvider', function($routeProvider) {
  $routeProvider.otherwise({redirectTo: REDIRECT_PATH });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/otherwise_route.js
// module id = 816
// module chunks = 3